export default __webpack_public_path__ + "static/media/print-icon.2bec4d1f.svg";